export default {
  isAuthenticated: state => state.isAuthenticated,
  tokenIsExpired: state => state.tokenExpires <= +new Date(),
};
